import { css } from "@emotion/react";
import { Button } from "../../general/Button/Button";
import { GlobalStore } from "../../../store/global/GlobalStore";

export const ContactUsError: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
      `}
    >
      Please try again or&nbsp;
      <Button
        buttonType={"link"}
        className="open-intercom-gtm"
        buttonCss={css`
          text-decoration: underline;
          padding: 0;
          color: ${theme.font.alerts.error};
        `}
      >
        contact us.
      </Button>
    </div>
  );
};
